import { computed, observable } from 'mobx';
import {RatecardsSchema} from '../../../types/schema';

export class PricingPageModel {
  @observable
  loading: boolean = true;

  @observable
  page_title: any = null;

  @observable
  page_body: any = null;

  @observable
  cover_image: any = null;

  @observable
  pricingImage: string;

  @observable
  ratecards: RatecardsSchema;

  @observable
  ratecardTypes: Array<{ value: string, label: string}> = [
    { value: 'standard', label: 'Non-Branded' },
    { value: 'brand_sponsored', label: 'Brand Sponsored' },
  ];

  @observable
  ratecardType: string = 'standard';

  @observable
  ratecardLoading: boolean = false;

  @computed
  get selectedRatecardType(): { value: string, label: string } {
    return this.ratecardTypes.find(t => t.value === this.ratecardType);
  }

  @observable
  video_id: string;

  @observable
  benefits: Array<{
    title: string;
    content: any;
  }>
}